"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("@angular/core");
class BucketsComponent {
    constructor() {
        this.controller = null;
        this.plugins = [];
        this.activeIndex = {};
    }
    ngOnInit() {
        this.plugins = this.controller.getActive(this.controller);
        // console.log ( 'BUCKETS INIT', this.controller, this.plugins );
    }
    getMyIndex(token) {
        let allActive = -1;
        let myIndex = 0;
        const keys = Object.keys(this.activeIndex);
        if (this.activeIndex) {
            keys.forEach(key => {
                if (this.activeIndex[key]) {
                    allActive++;
                }
                if (token == key) {
                    myIndex = allActive;
                }
            });
        }
        // console.log('#idx', token, allActive, myIndex, keys, this.activeIndex );
        return myIndex;
    }
    isActive(token) {
        this.activeIndex[token] = true;
    }
    isInactive(token) {
        this.activeIndex[token] = false;
    }
}
exports.BucketsComponent = BucketsComponent;
